import { ReportsPendingSelectionComponent } from './reports-pending-selection.component';

export default angular
  .module('sfMobile.components.reports-pending-selection', [])
  .component('sfReportsPendingSelection', ReportsPendingSelectionComponent)
  .name;
